module.exports = __webpack_public_path__ + "img/footer-logo.3df5e9b3.png";